<template>
  <div>
    <div class='clpp-api-example-caption' v-if='example.caption'>{{example.caption}}</div>
    <div class='clpp-api-example-code' >
      <pre><code class="language-javascript" v-html='code'>{{code}}</code></pre>
    </div>
  </div>
</template>

<script>
import Prism from 'prismjs';

import { DocsComponentMixin } from '../../utils/docs';

export default {
  mixins: [DocsComponentMixin],
  name: 'DocsDetailExample',
  props: ['example'],
  computed: {
    code () {
      return this.example.code;
    }
  },
  mounted () {
    Prism.highlightAll();
  },
};
</script>
